import { render, staticRenderFns } from "./GlyanecBooklet.vue?vue&type=template&id=544a8799&scoped=true&"
import script from "./GlyanecBooklet.vue?vue&type=script&lang=js&"
export * from "./GlyanecBooklet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a8799",
  null
  
)

export default component.exports